import { observeAttributes } from '@edicom/common/observer/observeAttributes';

export default {
  onUpdate: observeAttributes,
};
